import React, { useState } from "react";
import { Typography, Box } from "@bca/ui-library";
import { FilterAsCheckbox } from "./FilterAsCheckbox";
import { showMoreOptions } from "./filtersConfig";
import ShowMoreButton from "./ShowMoreButton";

const GroupedCheckboxList = ({
  filterKey,
  categoryKey,
  filterValues,
  selectedCheckboxes,
  onChange,
  parentFilterKey,
  setRefreshCollapsible,
}) => {
  const DEFAULT_VISIBLE_OPTIONS =
    showMoreOptions[categoryKey + "Subfilters"]?.visibleOptionsCount;
  const [sliceSize, setSliceSize] = useState(DEFAULT_VISIBLE_OPTIONS);
  return (
    <Box key={filterKey}>
      <Typography fontSize={1} color="grey-blue" mt={5}>
        {filterKey}
      </Typography>
      {filterValues?.slice(0, sliceSize).map(({ name, count }) => {
        return (
          <FilterAsCheckbox
            key={`${filterKey}-${name}`}
            id={name}
            label={name}
            resultsCount={count}
            isSelected={Boolean(
              selectedCheckboxes.find(
                (item) =>
                  item.filterKey === name &&
                  item.categoryKey === categoryKey &&
                  item.groupedBy === filterKey
              )
            )}
            onChange={() =>
              onChange(name, categoryKey, filterKey, parentFilterKey)
            }
          />
        );
      })}

      <ShowMoreButton
        categoryKey={categoryKey + "Subfilters"}
        filteredSubfilters={filterValues}
        sliceSize={sliceSize}
        setSliceSize={setSliceSize}
        setRefreshCollapsible={setRefreshCollapsible}
      />
    </Box>
  );
};

export default GroupedCheckboxList;
